import React, { FC } from "react";
import { StyledPanelHeader, PanelHeaderText } from "./Panel.styles";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

interface PanelHeaderProp {
  title?: React.ReactNode;
  backgroundColor?: string;
}

const PanelHeader: FC<PanelHeaderProp> = ({
  title,
  backgroundColor = DIGIPOSTHEME.colors.primaryAkbankWhite,
}) => {
  return (
    <StyledPanelHeader backgroundColor={backgroundColor} padding='0 20px 10px'>
      <PanelHeaderText>{title}</PanelHeaderText>
    </StyledPanelHeader>
  );
};

export default PanelHeader;
